<template>
  <form>
    <LoginTextField
      :autocomplete="false"
      autoFocus
      @input="handleInput"
      :label="label"
      :maxlength="6"
      :placeholder="placeholder"
      required
      :submitOnEnter="handleSubmit"
      :value="token"
      vvName="verification code"
    />
    <LoginActionButton
      :action="handleSubmit"
      :disabled="isDisabled"
      :isLoading="isLoading"
    >
      {{ buttonText }}
    </LoginActionButton>
  </form>
</template>

<script>
// Components
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginTextField from 'client/components/LoginTextField.vue';

export default {
  name: 'LoginInputConfirmation',

  computed: {
    isDisabled() {
      return this.token.length < 6;
    },
  },

  data: () => ({
    isLoadingReset: false,
  }),

  props: {
    buttonText: {
      type: String,
      default: 'Login',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Verification Code',
    },
    token: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Enter code from your mobile authenticator app:',
    },
  },

  components: {
    LoginActionButton,
    LoginTextField,
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
    handleSubmit(e) {
      this.$emit('onSubmit', e);
    },
  },
};
</script>
